import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { catchError, map, takeUntil, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { GuideActions } from '../actions/guide.actions';
import { GuideService } from '../services/guide.service';
import { Destroy } from '../../common-store/services/destroy.service';

@Injectable()
export class GuideEffects implements OnInitEffects {
  loadGuides$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GuideActions.loadGuides),
      exhaustMap(() => {
        return this.guideService.loadGuides().pipe(
          takeUntil(this.destroy$.destroySubject$),
          map((guides) => GuideActions.loadGuidesSuccess({ guides })),
          catchError((error) =>
            of(
              GuideActions.loadGuidesFailure({
                error: error.message ?? error,
              })
            )
          )
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private guideService: GuideService,
    private readonly destroy$: Destroy
  ) {}

  ngrxOnInitEffects(): Action {
    return GuideActions.loadGuides();
  }
}
